// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__dyd6I","selects":"Documents_selects__1lz8x"};